import { requireAnySystemPermission } from '../../../../backend/features/permissions/shared';
import { AccountSectionAdminPage } from './AccountSectionAdminPage';
import { DynamicColumnsPage } from './CustomFields/DynamicColumnsPage';
import { GroupSectionAdminPage } from './GroupSectionAdminPage';
import { OrganizationSectionAdminPage } from './OrganizationSectionAdminPage';
import { OrganizationTypeAdminPage } from './OrganizationTypeAdminPage';
import { PagerCarriersAdminPage } from './PagerCarrierAdminPage';
const groups = { general: 'General' };
/**
 * @deprecated use getContactManagementAdminPages
 */
export const contactManagementAdminPages = [
    { label: 'Account Section', name: 'account', path: 'account-section', groupLabel: groups.general, component: AccountSectionAdminPage },
    {
        label: 'Organization Section',
        name: 'organization',
        path: 'organization-section',
        groupLabel: groups.general,
        component: OrganizationSectionAdminPage,
    },
    {
        label: 'Organization Type',
        name: 'organization',
        path: 'organization-type',
        groupLabel: groups.general,
        component: OrganizationTypeAdminPage,
    },
    { label: 'Group Section', name: 'group', path: 'group-section', groupLabel: groups.general, component: GroupSectionAdminPage },
    { label: 'Pager Carrier', name: 'pagerCarrier', path: 'pager-carrier', groupLabel: groups.general, component: PagerCarriersAdminPage },
    {
        label: 'Custom Field',
        name: 'customField',
        path: 'custom-field',
        groupLabel: groups.general,
        component: DynamicColumnsPage,
    },
];
export const getContactManagementAdminPages = (userState) => {
    return requireAnySystemPermission(userState, 'manage-all-classifiers') ? [...contactManagementAdminPages] : [];
};
